module.exports = __webpack_public_path__ + "static/ar-logo100-web-fb5453553773d3dd9fbb6e8aa8292715.svg";